import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from '../helpers/common'
import EventEmitter, { RECALCULATE_SIZE_TRACKER } from '../helpers/EventEmitter'
import { UseTypeFontSize } from './hooks/useTypeFontSize'

export const SizeTracker = ({
  children,
  renderTopComponent,
  renderBottomComponent,
  topClassName,
  bottomClassName,
  id,
}) => {
  const typeFontSize = UseTypeFontSize()
  const locale = useSelector((state) => state.i18n.locale)
  const [size, setSize] = useState({})
  const topRef = useRef()
  const bottomRef = useRef()

  const calculateSize = () => {
    const size = [topRef.current, bottomRef.current].reduce(
      (result, item) => {
        if (item) {
          const size = item.getBoundingClientRect()
          result.width += size.width
          result.height += size.height
        }
        return result
      },
      { width: 0, height: 0 },
    )

    setSize(size)
  }

  useEffect(() => {
    calculateSize()
  }, [
    typeFontSize,
    locale,
    renderTopComponent,
    renderBottomComponent,
    topRef.current,
    bottomRef.current,
  ])

  useEffect(() => {
    const recalCulateSize = (data) => {
      if (data === id) {
        calculateSize()
      }
    }

    EventEmitter.subscribe(RECALCULATE_SIZE_TRACKER, recalCulateSize)

    return () => {
      EventEmitter.unsubscribe(RECALCULATE_SIZE_TRACKER, recalCulateSize)
    }
  }, [])

  useEffect(() => {
    const resize = debounce(() => {
      calculateSize()
    }, 100)

    window.addEventListener('resize', resize)
    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <>
      {renderTopComponent && (
        <div ref={topRef} className={topClassName}>
          {renderTopComponent(size)}
        </div>
      )}
      {children && children(size)}
      {renderBottomComponent && (
        <div ref={bottomRef} className={bottomClassName}>
          {renderBottomComponent(size)}
        </div>
      )}
    </>
  )
}

SizeTracker.propTypes = {
  children: PropTypes.any,
  renderTopComponent: PropTypes.func,
  renderBottomComponent: PropTypes.func,
  topClassName: PropTypes.string,
  bottomClassName: PropTypes.string,
}

SizeTracker.defaultProps = {
  topClassName: '',
  bottomClassName: '',
}
